import { red as muiRed } from "@mui/material/colors"

// BRANDING
export type BrandingColor = {
  main: string
  // Dark
  dark1: string
  dark2: string
  dark3: string
  dark4: string
  // Light
  light1: string
  light2: string
  light3: string
  light4: string
}

export interface YannColor extends BrandingColor {
  contrastText?: string
  // Dark
  dark4: string
  // Light
  light4: string
}

export const primary: YannColor = {
  main: "#2854a1",
  contrastText: "#fff",
  // Dark
  dark1: "#1d3e76",
  dark2: "#466cae",
  dark3: "#6c8abf",
  dark4: "#89a1cb",
  // Light
  light1: "#a1b4d6",
  light2: "#b6c5df",
  light3: "#c8d4e7",
  light4: "#dae1ef",
}

export const secondary: YannColor = {
  main: "#1db778",
  contrastText: "#fff",
  // Dark
  dark1: "#0c492f",
  dark2: "#147b50",
  dark3: "#199c66",
  dark4: "#1db676",
  // Light
  light1: "#51c796",
  light2: "#7bd5b0",
  light3: "#9fe0c5",
  light4: "#beead8",
}

export const tertiary: YannColor = {
  main: "#951B81",
  // Dark
  dark1: "#721564",
  dark2: "#a9459a",
  dark3: "#bc6eb0",
  dark4: "#c98cc0",
  // Light
  light1: "#d5a4cd",
  light2: "#deb8d9",
  light3: "#e7cbe3",
  light4: "#eedbeb",
}

export const purple = {
  main: "#9c42bd",
  // Dark
  dark1: "#8c20b1",
  dark2: "#7e1fab",
  dark3: "#691ba3",
  dark4: "#32128d",
  // Light
  light1: "#ad63c9",
  light2: "#c58fd9",
  light3: "#dbbce7",
  light4: "#f1e4f5",
}

export const grey = {
  dark: "#666c75",
  light: "#a9afb8",
  disabled: "#c0c3c6",
  // Not in the Abstract palette
  extraLight: "#e5e7e9",
}

export const red = {
  main: muiRed["400"],
  // Dark
  dark1: muiRed["700"],
  dark2: muiRed["800"],
  dark3: muiRed["900"],
  dark4: muiRed.A700,
  // Light
  light1: muiRed["50"],
  light2: muiRed["100"],
  light3: muiRed["200"],
  light4: muiRed["300"],
}

export const branding: BrandingColor = {
  main: "",
  // Dark
  dark1: "",
  dark2: "",
  dark3: "",
  dark4: "",
  // Light
  light1: "",
  light2: "",
  light3: "",
  light4: "",
}

export const brandingAccent: BrandingColor = {
  main: "",
  // Dark
  dark1: "",
  dark2: "",
  dark3: "",
  dark4: "",
  // Light
  light1: "",
  light2: "",
  light3: "",
  light4: "",
}

export type OtherColors = typeof other
export const other = {
  blueGreenDark: "#64999a",
  blueGreen: "#6cabad",
  blueGreen1: "#7abcbc",
  blueGreen2: "#addcdc",
  paleCyan: "#C2DCE5",
  lightCyan: "#A6E7F6",
  aqua: "#9ce3e5",
  darkBlue: "#0c233d",
  electricBlue: "#1085ff",
  blue: "#5a8ce4",
  kawaiiBlue: "#799EE0",
  skyBlue: "#99CDE0",
  paleBlue: "#8da2c6",
  lightBlue: "#e6f1fd",
  periwinkleBlue: "#e2e9fc",
  ghostBlue: "#F4F7FF",
  digitalLavender: "#e5e9ff",
  americanDiamond: "#F2F5F8",
  rareBlue: "#328CAB",
  tealBlueDark2: "#296d77",
  tealBlueDark1: "#006370",
  tealBlue: "#317e89",
  ufoGreen: "#00d98a",
  mediumSeaGreen: "#1db778",
  midnightGreen: "#024750",

  red: "#f03308",
  greenLight1: "#b5d293",
  green: "#c0cb00",
  brightGreen: "#00d56d",
  goldenYellow: "#FFDD00",
  orange: "#f9b000",
  orangeDark1: "#f38c11",
  orangeDark2: "#ff6c00",
  orangeDark3: "#fe4921",
  pink: "#e44881",
  lightPink: "#F68FC3",

  pinky: "#ff94bc",
  blush: "#FFD8D5",
  violet: "#bfb5fe",
  lavender: "#C99BF5",
  darkViolet: "#9c42bd",
  turquoise: "#8fd9ff",
  boldTurquoise: "#04D8C6",
  salmon: "#fec7b5",

  cloudGray: "#c9d0d6",
  cloudWhite: "#f6f6fb",
  blueWhite: "#f5f7fb",

  white: "#fff",
  black: "#000",
}
